import axios from "axios";

const axiosConfig = {
  baseURL: process.env.REACT_APP_USE_LOCAL_API
    ? `https://${window.location.hostname}:8443`
    : process.env.REACT_APP_API_URL,
  withCredentials: true,
  timeout: 5000,
};

const axiosInstance = axios.create(axiosConfig);

export default axiosInstance;
